import {ThunkActionCreator} from "../interfaces/thunk";
import {Dispatch} from "../interfaces/dispatch";
import axios from "axios";
import Config from "../config";
import {getHeaders} from "../helpers/headers";
import {AnyAction} from "../interfaces/action";
import {handleActions} from "redux-actions";

// AbortController for cancelling previous requests to prevent race conditions
let storeSummaryController: AbortController | null = null;
let storeSummaryFiltersController: AbortController | null = null;

function getCancelableStoreSummaryAxios() {
  if (storeSummaryController) {
    storeSummaryController.abort();
  }
  storeSummaryController = new AbortController();
  return { signal: storeSummaryController.signal };
}

function getCancelableFiltersAxios() {
  if (storeSummaryFiltersController) {
    storeSummaryFiltersController.abort();
  }
  storeSummaryFiltersController = new AbortController();
  return { signal: storeSummaryFiltersController.signal };
}

export const FETCH_FILTER_INFO_REQUEST = "FETCH_FILTER_INFO_REQUEST"
export const FETCH_FILTER_INFO = "FETCH_FILTER_INFO"
export const FETCH_FILTER_INFO_FAILED = "FETCH_FILTER_INFO_FAILED"
export const FETCH_STORE_SUMMARY_REPORT_REQUEST = "FETCH_STORE_SUMMARY_REPORT_REQUEST";
export const FETCH_STORE_SUMMARY_REPORT = "FETCH_STORE_SUMMARY_REPORT";
export const FETCH_STORE_SUMMARY_REPORT_FAILED = "FETCH_STORE_SUMMARY_REPORT_FAILED";
export const FETCH_COMPARISON_STORE_SUMMARY_REPORT_REQUEST = "FETCH_COMPARISON_STORE_SUMMARY_REPORT_REQUEST";
export const FETCH_COMPARISON_STORE_SUMMARY_REPORT = "FETCH_COMPARISON_STORE_SUMMARY_REPORT";
export const FETCH_COMPARISON_STORE_SUMMARY_REPORT_FAILED = "FETCH_COMPARISON_STORE_SUMMARY_REPORT_FAILED";

const fetchStoreSummaryFilters: ThunkActionCreator<Promise<void>> = (id,segmentationType:any) => (dispatch: Dispatch) => {
  const { signal } = getCancelableFiltersAxios();
  dispatch({ type: FETCH_FILTER_INFO_REQUEST });
  const params = new URLSearchParams();

  if (segmentationType) {
    params.set("segmentationType", segmentationType);
  }
  return axios
    .get(`${Config.API_SERVICE_URL}/api/reports/storeSummary/dropdowns/${id}?${params.toString()}`, { ...getHeaders(), signal })
    .then((response) => {
      dispatch({ type: FETCH_FILTER_INFO, payload: response.data });
    })
    .catch((err) => {
      if (err.name === "CanceledError") {
        console.log("Previous store summary filters request cancelled");
      } else {
      dispatch({ type: FETCH_FILTER_INFO_FAILED });
      }
    });
}

const fetchStoreSummaryInfo: ThunkActionCreator<Promise<void>> =
  (id:number,storeParameter:string,segmentationTypes:string,segmentationFilter:string[],storeIds: number[] = [], page: number = 0, pageSize: number = 10,hasComparison: string,     sortBy: string = "",        // ← add
    sortOrder: string = "desc") => (dispatch: Dispatch) => {
    const { signal } = getCancelableStoreSummaryAxios();
    dispatch({ type: FETCH_STORE_SUMMARY_REPORT_REQUEST });
    // const params = new URLSearchParams();
    // if (storeParameter) {
    //   params.set("storeParameter", storeParameter);
    // }
    // if (segmentationTypes) {
    //   params.set("segmentationType", segmentationTypes);
    // }
    // if (Array.isArray(segmentationFilter) && segmentationFilter.length > 0) {
    //   params.set("filterSegmentation", segmentationFilter.join(","));
    // }
    // if (Array.isArray(storeIds) && storeIds.length > 0) {
    //   params.set("storeIds", storeIds.join(","));
    // }
    // if(hasComparison){
    //   params.set("comparisonProject", hasComparison);
    // }
    // if (sortBy) {
    //   params.set("sortBy", sortBy);
    // }
    // params.set("sortOrder", sortOrder);
    //
    // params.set("page", String(page));
    // params.set("pageSize", String(pageSize));
    const body = {
      "projectId":id,
      "storeParameter":storeParameter?storeParameter:[],
      "segmentationType":segmentationTypes?segmentationTypes:[],
      "filterSegmentation":segmentationFilter?segmentationFilter.join(","):[],
      "storeIds":storeIds?storeIds.join(","):[],
      "comparisonProject":hasComparison?hasComparison:"",
      "sortBy":sortBy,
      "sortOrder":sortOrder,
      "page":String(page),
      "pageSize": String(pageSize)
    }
    return axios
      .post(`${Config.API_SERVICE_URL}/api/reports/storeSummaryDetails`,body, { ...getHeaders(), signal })
      .then((response) => {

        dispatch({ type: FETCH_STORE_SUMMARY_REPORT, payload: response.data });
      })
      .catch((err) => {
        if (err.name === "CanceledError") {
          console.log("Previous store summary request cancelled");
        } else {
        dispatch({ type: FETCH_STORE_SUMMARY_REPORT_FAILED });
        }
      });
}

const fetchComparisonStoreSummaryInfo: ThunkActionCreator<Promise<void>> =
  (id:number,comparisonId:number,storeParameter:string,segmentationTypes:string,segmentationFilter:any,storeIds: number[] = []) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_COMPARISON_STORE_SUMMARY_REPORT_REQUEST });
    const params = new URLSearchParams();

    if (storeParameter) {
      params.set("storeParameter", storeParameter);
    }
    if (segmentationTypes) {
      params.set("segmentationType", segmentationTypes);
    }
    if (Array.isArray(segmentationFilter) && segmentationFilter.length > 0) {
      params.set("segmentationFilter", segmentationFilter.join(","));
    }
    if (Array.isArray(storeIds) && storeIds.length > 0) {
      params.set("storeIds", storeIds.join(","));
    }
    return axios
      .get(`${Config.API_SERVICE_URL}/api/reports/storeSummary/${id}/${comparisonId}?${params.toString()}`, getHeaders())
      .then((response) => {
        dispatch({ type: FETCH_COMPARISON_STORE_SUMMARY_REPORT, payload: response.data });
      })
      .catch((_) => {
        dispatch({ type: FETCH_COMPARISON_STORE_SUMMARY_REPORT_FAILED });
      });
  }


const actions = {
  [FETCH_FILTER_INFO_REQUEST]: (state: StoreSummaryReportState) => ({
    ...state,
    filtersLoading: true,
  }),
  [FETCH_FILTER_INFO]: (state: StoreSummaryReportState, action: AnyAction): StoreSummaryReportState => ({
    ...state,
    filtersLoading: false,
    filters: { ...action.payload },
  }),
  [FETCH_FILTER_INFO_FAILED]: (state: StoreSummaryReportState) => ({
    ...state,
    filtersLoading: false,
    error: true,
    filters: undefined,
  }),
  [FETCH_STORE_SUMMARY_REPORT_REQUEST]: (state: StoreSummaryReportState) => ({
    ...state,
    loading: true,
    content: {}
  }),
  [FETCH_STORE_SUMMARY_REPORT]: (state: StoreSummaryReportState, action: AnyAction): StoreSummaryReportState => ({
    ...state,
    loading: false,
    content: {...action.payload} ,
  }),
  [FETCH_STORE_SUMMARY_REPORT_FAILED]: (state: StoreSummaryReportState) => ({
    ...state,
    loading: false,
    error: true,
    content: undefined,
  }),

  [FETCH_COMPARISON_STORE_SUMMARY_REPORT_REQUEST]: (state: StoreSummaryReportState) => ({
    ...state,
    loading: true,
    content: {}
  }),
  [FETCH_COMPARISON_STORE_SUMMARY_REPORT]: (state: StoreSummaryReportState, action: AnyAction): StoreSummaryReportState => ({
    ...state,
    loading: false,
    comparisonData: {...action.payload} ,
  }),
  [FETCH_COMPARISON_STORE_SUMMARY_REPORT_FAILED]: (state: StoreSummaryReportState) => ({
    ...state,
    loading: false,
    error: true,
    comparisonData: undefined,
  }),
}


export interface StoreSummaryReportState {
  content: any;
  error: boolean;
  loading: boolean;
  filtersLoading: boolean;
  filters:any
  comparisonData:any
}

const initialState: StoreSummaryReportState = {
  loading: false,
  filtersLoading: false,
  error: false,
  content: {},
  filters:{},
  comparisonData:{}
};
export {fetchStoreSummaryFilters,fetchStoreSummaryInfo,fetchComparisonStoreSummaryInfo}

export default handleActions<StoreSummaryReportState, AnyAction>(actions, initialState);
